import { useEffect, useState } from "react";
import axios from "axios";
import { Briefcase, Sparkles, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CV() {
  const [cv, setCv] = useState({ intro: "", experience: [], skills: [] });

  useEffect(() => {
    axios.get(`${API}/cv`).then((res) => setCv(res.data)).catch(() => {});
  }, []);

  const { intro, experience, skills } = cv;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24" data-testid="cv-page">
      <p className="font-mono text-xs sm:text-sm font-medium uppercase tracking-[0.2em] text-amber-700">CV</p>
      <h1 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-stone-900" data-testid="cv-heading">
        Abhishek Bhattacharjee
      </h1>
      <p className="mt-4 max-w-2xl text-base sm:text-lg text-stone-600 leading-relaxed" data-testid="cv-intro">
        {intro}
      </p>

      {/* Experience */}
      <section className="mt-16">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-100">
            <Briefcase className="h-5 w-5 text-amber-700" />
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-stone-900" data-testid="cv-experience-heading">
            Experience
          </h2>
        </div>
        <div className="mt-8 space-y-6">
          {experience.map((job, i) => (
            <div
              key={i}
              className="rounded-3xl border border-stone-200 bg-white p-8 shadow-sm"
              data-testid={`cv-experience-card-${i}`}
            >
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <h3 className="font-heading text-xl sm:text-2xl font-semibold text-stone-900">{job.role}</h3>
                <span className="font-mono text-xs uppercase tracking-widest text-amber-700">{job.period}</span>
              </div>
              <p className="mt-1 text-sm font-semibold text-stone-500">{job.company}</p>
              <p className="mt-4 text-base text-stone-600 leading-relaxed">{job.details}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Skills */}
      <section className="mt-16">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-100">
            <Sparkles className="h-5 w-5 text-amber-700" />
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-stone-900" data-testid="cv-skills-heading">
            Skills
          </h2>
        </div>
        <div className="mt-8 flex flex-wrap gap-3" data-testid="cv-skills-list">
          {skills.map((skill, i) => (
            <span
              key={`${skill}-${i}`}
              data-testid={`cv-skill-chip-${i}`}
              className="rounded-full border border-stone-200 bg-white px-5 py-2.5 text-sm font-semibold text-stone-700 transition-all hover:border-amber-400 hover:text-amber-700 hover:-translate-y-0.5"
            >
              {skill}
            </span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="mt-16">
        <div className="rounded-3xl border border-stone-200 bg-cream/70 p-8 sm:p-12" data-testid="cv-cta-section">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-stone-900">
            Want to work together — or pick my brain?
          </h2>
          <p className="mt-4 max-w-xl text-base sm:text-lg text-stone-600 leading-relaxed">
            I take 1:1 consultations on Topmate — whether it's breaking into adtech, scaling performance campaigns, or
            growing across India &amp; SEA.
          </p>
          <a
            href="https://topmate.io/bhattacharjee_abhishek"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cv-topmate-cta-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-amber-600 px-8 py-3.5 text-sm font-semibold text-white transition-all hover:bg-amber-700 hover:-translate-y-0.5"
          >
            Book a consultation on Topmate
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </section>
    </div>
  );
}
